
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.221","stroke-linecap":"round","stroke-linejoin":"round","fill-rule":"nonzero","fill":"none"}},[_c('path',{attrs:{"d":"M13.75 17.833h-3.5c-2.917 0-4.083-1.166-4.083-4.083v-3.5c0-2.917 1.166-4.083 4.083-4.083h3.5c2.917 0 4.083 1.166 4.083 4.083v3.5c0 2.917-1.166 4.083-4.083 4.083z"}}),_c('path',{attrs:{"d":"M12.583 9.667a1.167 1.167 0 102.334 0 1.167 1.167 0 00-2.334 0zM17.443 16.054l-2.876-1.93c-.461-.31-1.126-.275-1.54.081l-.193.17a1.3 1.3 0 01-1.645 0l-2.426-2.083a1.3 1.3 0 00-1.645 0l-.951.816"}})])])
          )
        }
      }
    